import { render } from "./FollowerLookupDrawer.vue?vue&type=template&id=6b2dfbec&scoped=true"
import script from "./FollowerLookupDrawer.vue?vue&type=script&lang=js"
export * from "./FollowerLookupDrawer.vue?vue&type=script&lang=js"

import "./FollowerLookupDrawer.vue?vue&type=style&index=0&id=6b2dfbec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2dfbec"]])

export default __exports__